import { render, staticRenderFns } from "./ATSForm.vue?vue&type=template&id=baa1b244&"
import script from "./ATSForm.vue?vue&type=script&lang=js&"
export * from "./ATSForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports